import { useContext } from 'react'

import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import OutreachMessageContext from '../OutreachMessageProvider/Context'

const useStyles = makeStyles(() => ({
  inherited: {
    fontSize: 'inherit',
  },
}))

const TriggerCell = ({
  trigger,
  priority,
  supportsStudentOutreach,
}: {
  trigger: string
  priority: number
  supportsStudentOutreach: boolean
}) => {
  const classes = useStyles()
  const { messages } = useContext(OutreachMessageContext)
  const totalTriggerMessages = messages?.automated?.filter((msg) => msg.Trigger === trigger).length || 0
  const triggerEvent = () => {
    switch (trigger) {
      case 'On-Follow':
        return 'Follow'
      case 'Marked-Applying':
        return 'Marked as Applying'
      case 'Marked-Applied':
        return 'Marked as Applied'
      default:
        return trigger
    }
  }
  return (
    <div>
      <div>{triggerEvent()}</div>
      {supportsStudentOutreach && (
        <Typography
          className={classes.inherited}
          color="textSecondary"
        >
          Priority {`${priority} of ${totalTriggerMessages}`}
        </Typography>
      )}
    </div>
  )
}
export default TriggerCell
